import { useId } from 'react';
import { SVGProps } from '../types';

export const SystemFolderClosedIcon = (props: SVGProps) => {
  const reactId = useId();
  const maskId = `mask-${reactId}`;
  const g0 = `g0-${reactId}`;
  const g1 = `g1-${reactId}`;
  const g2 = `g2-${reactId}`;

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask id={maskId} fill="white">
        <path d="M4.7627 1C6.19734 1 7.55527 2.33301 8.98992 2.33301H10.667C12.5333 2.33301 13.4667 2.33319 14.1797 2.69629C14.8069 3.01586 15.3171 3.52612 15.6367 4.15332C16 4.86636 16 5.80015 16 7.66699V9.66699C16 11.5334 15.9999 12.4667 15.6367 13.1797C15.3171 13.8069 14.8069 14.3171 14.1797 14.6367C13.4667 14.9999 12.5334 15 10.667 15H5.33301C3.46659 15 2.53328 14.9999 1.82031 14.6367C1.19311 14.3171 0.682859 13.8069 0.363281 13.1797C0.000110411 12.4667 1.23378e-09 11.5334 0 9.66699V7.66699C0 7.23083 0.000249491 6.8453 0.00488281 6.50195C0.00207341 6.46749 0 6.43265 0 6.39746V4.33301C0.000175038 2.49232 1.49232 1.00018 3.33301 1H4.7627Z" />
      </mask>
      <path
        d="M4.7627 1C6.19734 1 7.55527 2.33301 8.98992 2.33301H10.667C12.5333 2.33301 13.4667 2.33319 14.1797 2.69629C14.8069 3.01586 15.3171 3.52612 15.6367 4.15332C16 4.86636 16 5.80015 16 7.66699V9.66699C16 11.5334 15.9999 12.4667 15.6367 13.1797C15.3171 13.8069 14.8069 14.3171 14.1797 14.6367C13.4667 14.9999 12.5334 15 10.667 15H5.33301C3.46659 15 2.53328 14.9999 1.82031 14.6367C1.19311 14.3171 0.682859 13.8069 0.363281 13.1797C0.000110411 12.4667 1.23378e-09 11.5334 0 9.66699V7.66699C0 7.23083 0.000249491 6.8453 0.00488281 6.50195C0.00207341 6.46749 0 6.43265 0 6.39746V4.33301C0.000175038 2.49232 1.49232 1.00018 3.33301 1H4.7627Z"
        fill="#027ED4"
      />
      <path
        d="M10.667 2.33301V1.91634V2.33301ZM14.1797 2.69629L14.3688 2.32504L14.3688 2.325L14.1797 2.69629ZM15.6367 4.15332L16.008 3.96416V3.96415L15.6367 4.15332ZM16 9.66699H16.4167H16ZM15.6367 13.1797L16.008 13.3688L16.008 13.3688L15.6367 13.1797ZM14.1797 14.6367L14.3688 15.008L14.3688 15.008L14.1797 14.6367ZM10.667 15V15.4167V15ZM5.33301 15V15.4167V15ZM1.82031 14.6367L1.63115 15.008L1.63119 15.008L1.82031 14.6367ZM0.363281 13.1797L-0.00799344 13.3688L-0.00797146 13.3688L0.363281 13.1797ZM0 9.66699H-0.416667H0ZM0.00488281 6.50195L0.421512 6.50758L0.421778 6.48781L0.420172 6.4681L0.00488281 6.50195ZM0 4.33301L-0.416667 4.33297V4.33301H0ZM3.33301 1V0.583333H3.33297L3.33301 1ZM8.98992 2.33301V2.74967H10.667V2.33301V1.91634H8.98992V2.33301ZM10.667 2.33301V2.74967C11.607 2.74967 12.287 2.75004 12.8219 2.79377C13.3519 2.83709 13.7026 2.92091 13.9906 3.06758L14.1797 2.69629L14.3688 2.325C13.9438 2.10857 13.4713 2.01074 12.8898 1.9632C12.3131 1.91606 11.5933 1.91634 10.667 1.91634V2.33301ZM14.1797 2.69629L13.9905 3.06754C14.5393 3.34717 14.9858 3.79369 15.2655 4.34249L15.6367 4.15332L16.008 3.96415C15.6484 3.25856 15.0745 2.68456 14.3688 2.32504L14.1797 2.69629ZM15.6367 4.15332L15.2655 4.34248C15.4122 4.63046 15.496 4.98121 15.5393 5.5114C15.583 6.04643 15.5833 6.72669 15.5833 7.66699H16H16.4167C16.4167 6.74045 16.417 6.02039 16.3699 5.44356C16.3224 4.86188 16.2246 4.38922 16.008 3.96416L15.6367 4.15332ZM16 7.66699H15.5833V9.66699H16H16.4167V7.66699H16ZM16 9.66699H15.5833C15.5833 10.6071 15.583 11.2871 15.5393 11.8219C15.4959 12.3519 15.4121 12.7026 15.2654 12.9906L15.6367 13.1797L16.008 13.3688C16.2245 12.9438 16.3223 12.4713 16.3698 11.8898C16.417 11.3132 16.4167 10.5933 16.4167 9.66699H16ZM15.6367 13.1797L15.2655 12.9905C14.9858 13.5393 14.5393 13.9858 13.9905 14.2655L14.1797 14.6367L14.3688 15.008C15.0745 14.6484 15.6484 14.0745 16.008 13.3688L15.6367 13.1797ZM14.1797 14.6367L13.9906 14.2654C13.7026 14.4121 13.3519 14.4959 12.8219 14.5393C12.2871 14.583 11.6071 14.5833 10.667 14.5833V15V15.4167C11.5933 15.4167 12.3132 15.417 12.8898 15.3698C13.4713 15.3223 13.9438 15.2245 14.3688 15.008L14.1797 14.6367ZM10.667 15V14.5833H5.33301V15V15.4167H10.667V15ZM5.33301 15V14.5833C4.39294 14.5833 3.7129 14.583 3.17806 14.5393C2.64807 14.4959 2.29741 14.4121 2.00943 14.2654L1.82031 14.6367L1.63119 15.008C2.05618 15.2245 2.52866 15.3223 3.11017 15.3698C3.68683 15.417 4.40666 15.4167 5.33301 15.4167V15ZM1.82031 14.6367L2.00948 14.2655C1.46067 13.9858 1.01416 13.5393 0.734534 12.9905L0.363281 13.1797L-0.00797146 13.3688C0.351554 14.0745 0.925542 14.6484 1.63115 15.008L1.82031 14.6367ZM0.363281 13.1797L0.734556 12.9906C0.587864 12.7026 0.504051 12.3519 0.460733 11.8219C0.417018 11.2871 0.416667 10.6071 0.416667 9.66699H0H-0.416667C-0.416667 10.5933 -0.416963 11.3132 -0.36983 11.8898C-0.3223 12.4713 -0.224472 12.9438 -0.00799344 13.3688L0.363281 13.1797ZM0 9.66699H0.416667V7.66699H0H-0.416667V9.66699H0ZM0 7.66699H0.416667C0.416667 7.23031 0.416923 6.84763 0.421512 6.50758L0.00488281 6.50195L-0.411746 6.49633C-0.416424 6.84298 -0.416667 7.23135 -0.416667 7.66699H0ZM0.00488281 6.50195L0.420172 6.4681C0.417817 6.43921 0.416667 6.41681 0.416667 6.39746H0H-0.416667C-0.416667 6.4485 -0.41367 6.49577 -0.410407 6.5358L0.00488281 6.50195ZM0 6.39746H0.416667V4.33301H0H-0.416667V6.39746H0ZM0 4.33301L0.416667 4.33305C0.41682 2.72244 1.72244 1.41682 3.33305 1.41667L3.33301 1L3.33297 0.583333C1.26219 0.583531 -0.41647 2.26219 -0.416667 4.33297L0 4.33301ZM3.33301 1V1.41667H4.7627V1V0.583333H3.33301V1ZM4.7627 1V1.41667C5.36809 1.41667 5.97768 1.69926 6.69681 2.04253C7.37397 2.36576 8.16066 2.74967 8.98992 2.74967V2.33301V1.91634C8.38453 1.91634 7.77493 1.63375 7.0558 1.29048C6.37864 0.967246 5.59195 0.583333 4.7627 0.583333V1Z"
        fill={`url(#${g0})`}
        mask={`url(#${maskId})`}
      />
      <rect
        x="0.208333"
        y="4.54165"
        width="15.5833"
        height="10.25"
        rx="3.125"
        fill="#027ED4"
        stroke={`url(#${g1})`}
        stroke-width="0.416667"
      />
      <rect
        opacity="0.2"
        y="4.33331"
        width="16"
        height="10.6667"
        rx="3.33333"
        fill={`url(#${g2})`}
      />
      <defs>
        <linearGradient
          id={g0}
          x1="8"
          y1="1"
          x2="8"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0.12" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id={g1}
          x1="8"
          y1="4.33331"
          x2="8"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0.12" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id={g2}
          x1="0"
          y1="4.33331"
          x2="11.0031"
          y2="14.6408"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
